import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const MobileTrigger = styled.button`
  display: none;

  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    width: 100%;
    padding: ${space[3]} ${space[4]};
    background: ${semantic.bg.overlayBlur};
    backdrop-filter: blur(${space[2]});
    border: none;
    border-radius: 28px;
    cursor: pointer;
    font-family: ${fonts.body};
    color: ${semantic.text.primary};
  }
`;

export const MobileTriggerTitle = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.white};
  text-align: center;
  overflow-wrap: break-word;
  max-width: 100%;
`;

export const MobileTriggerSubtitle = styled.span`
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  text-align: center;
  overflow-wrap: break-word;
  max-width: 100%;
`;

export const MobileModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${colors.white};
  z-index: ${layout.zIndexModal};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
